export default __webpack_public_path__ + "static/media/logo-mtlogin-blue-icon.b41518c1.svg";